import React, { useEffect, useRef, useState } from "react";

import * as d3 from "d3";

import { entities } from "Libs/platform";
import LogModal from "src/organization/common/components/ActivityList/LogModal/LogModal";
import { useHttpMetricsContext } from "src/organization/pages/project/environment/metrics/http/context";

import { isAutoscaleType } from "./../../../components/Chart/utils";
import { ActivityGroup } from "./style";

import type { Activity } from "@packages/client";

type ActivityType = {
  yScale: d3.ScaleLinear<any, any>;
  xScale: d3.ScaleTime<any, any>;
  resourceName?: string;
};

const Activities = (props: ActivityType) => {
  const { yScale, xScale, resourceName } = props;
  const [y1, y2] = [yScale.range()[0], yScale.range()[1]];
  const activityRef = useRef<SVGGElement | null>(null);
  const httpMetricsContext = useHttpMetricsContext();
  const [activity, setActivity] = useState<Activity>();

  useEffect(() => {
    const selection = d3.select(activityRef.current);
    const activities = httpMetricsContext?.activities || [];

    const filteredActivities =
      resourceName === "cpu"
        ? activities
        : activities?.filter(
            activity => activity?.type === "environment.redeploy"
          );

    selection
      .selectAll("line")
      .data(filteredActivities)
      .join("line")
      .style("stroke", d =>
        isAutoscaleType(d?.payload?.deployment_type)
          ? "var(--theme-warning-600)"
          : "var(--theme-neutral-200)"
      )
      .attr("y1", y1)
      .attr("y2", y2)
      .attr("x1", d => xScale(new Date(d.created_at)))
      .attr("x2", d => xScale(new Date(d.created_at)))
      .attr("class", "activity-line")
      .attr("data-activityId", d => d.id)
      .on("click", (e, d) =>
        setActivity(new entities.Activity(d, d?._links?.self?.href!))
      );

    selection
      .selectAll("circle")
      .data(
        resourceName === "cpu"
          ? activities.filter(d => isAutoscaleType(d?.payload?.deployment_type))
          : []
      )
      .join("circle")
      .attr("cx", d => xScale(new Date(d.created_at)))
      .attr("cy", y2)
      .attr("r", 2)
      .attr("fill", "var(--theme-warning-600)")
      .attr("class", "activity-dot");
  }, [y1, y2, xScale, httpMetricsContext, resourceName]);

  return (
    <>
      <ActivityGroup className="deployment-activities" ref={activityRef} />
      {activity && (
        <LogModal
          initialActivity={activity}
          closeModal={() => setActivity(undefined)}
        />
      )}
    </>
  );
};

export default Activities;
